import { useCallback } from 'react';
import { useAppGoogleAnalytics } from './useAppGoogleAnalytics';
var useFeatureGoogleAnalytics = function (category) {
    var ga4 = useAppGoogleAnalytics();
    var sendEvent = useCallback(function (action, label) {
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsTeacher({
            action: action,
            category: category,
            label: label,
        });
    }, [ga4]);
    return sendEvent;
};
export { useFeatureGoogleAnalytics };
